// This library is inspired by RDFS.

// TODO add throwing errors...

// import { rdflib } from 'rdflib'

import { Namespaces } from '@/rec-cache/rec-cache-namespaces'
import { Iri, Literal } from '@/rec-cache/rec-cache-types'

import serialization from '@/wob-ontology-services/wob-ontology-reduced.json'
console.log('SERIALIZATION', serialization)
// TODO update parameters to be right types...
// TODO literal should be a language string...
// TODO need to fix namespaces for the iris...

class Restriction {
  constructor() {}
}

// The type restriction represent a SHACL nodeshape with targetSubjectsOf rdf:type, ie allowed classes.
// It is implied that inference takes place on the classes, ie that ontology sub classes are implied.
class TypeRestriction extends Restriction {
  constructor(types = []) {
    super()
    this._types = types
  }

  get types() {
    return this._types
  }

  add(type) {
    this._types.push(type)
    return this
  }
}

// The object property restriction mimics a SHACL nodeshape with target classes (sources) and
// including one property shape with a path (type) and potentially several values (targets).
// TODO deal with potential "open ended" relationships, ie no rdfs:domain or dtdl:target.
class ObjectPropRestriction extends Restriction {
  // The type parameter is an Iri, sources and targets parameters are each an Iri or arrays of Iris.
  // TODO type check the content of sources and targets... potentially call factory if not an Iri.
  constructor(type, sources = null, targets = null) {
    super()
    this._type = type
    this._sources = sources
      ? Array.isArray(sources)
        ? sources
        : [sources]
      : []
    this._targets = targets
      ? Array.isArray(targets)
        ? targets
        : [targets]
      : []
  }

  get type() {
    return this._type
  }

  get sources() {
    return this._sources
  }

  get targets() {
    return this._targets
  }

  get hasTarget() {
    return this._targets.length > 0
  }

  // Returns array of triple arrays (each triple array being source, type, target Iris -> subject, predicvtae, object)
  // TODO will fail (or rather return an empty target, null or undefined) if target is not defined
  get triples() {
    const _triples = []
    this._sources.forEach((source) => {
      this._targets.forEach((target) => {
        _triples.push([source, this._type, target])
      })
    })
    return _triples
  }

  // Parameter type is an Iri.
  setType(type) {
    if (this._type) {
      // TODO what to do if type is already set? Currently doesnt change an return with previous object property type.
      true
    } else this._type = type
    return this
  }

  // Both parameters are Iri.
  add(source, target) {
    // TODO add parameter checks.
    this._sources.push(source)
    this._targets.push(target)
    return this
  }

  // TODO maxCount must be a positive integer, not zero... test and throw???
  setMaxCount(maxCount) {
    this._maxCount = maxCount
    return this
  }

  get hasMaxCount() {
    return this._maxCount
  }
}

/*
class Shape {
  constructor(closed = true) {
    this.targetClass = []
    this.targetSubjectsOf = []
    this.closed = closed
  }
  validate(type) {
    return type
  }
}

class NodeShape extends Shape {
  constructor() {
    super()
    this.property = []
  }
  addProperty(property) {
    this.property.push(property)
    return this
  }
}

class PropertyShape extends Shape {
  constructor() {
    super()
    this.path = new Iri()
    this.type = new Iri()
  }
  setPath(path) {
    this.path = path
    return this
  }
  setClass(type) {
    this.type = type
    return this
  }
}
  */

// Parameter type is an Iri and parameter subClasses is an array of Iri.
// Parameter label is a Literal.
class OntoClass {
  constructor(type, label = '', superClasses = []) {
    this._type = type
    this._label = label
    this._subClassOf = superClasses
  }

  get isRoot() {
    return this._subClassOf.length == 0
  }

  get type() {
    return this._type
  }

  set type(type) {
    this._type = type
  }

  get subClassOf() {
    return this._subClassOf
  }

  // Other name for above.
  get superclasses() {
    return this.subClassOf
  }

  set subClassOf(subClasses) {
    this._subClassOf = subClasses
  }

  // Parameter superCLass is an Iri.
  addSubClassOf(superClass) {
    if (this._subClassOf.find((c) => c.type.equals(superClass))) {
      // Only add if not already in super classes (subClassOf) array.
      true
    } else this._subClassOf.push(superClass)
  }

  // Parameter parent is an Iri
  hasParent(parent) {
    return this._subClassOf.filter((sc) => sc.equals(parent)).length > 0
  }

  // Parameter type is an Iri
  hasType(type) {
    return this._type.equals(type)
  }
}

// Parameter type is an Iri.
// Parameters ranges and domains are arrays of type Iri.
class OntoProp {
  constructor(type, ranges = [], domains = []) {
    this._type = type
    this._ranges = ranges
    this._domains = domains
  }

  get type() {
    return this._type
  }

  get ranges() {
    return this._ranges
  }

  get domains() {
    return this._domains
  }

  get hasRanges() {
    return this._ranges.length > 0
  }

  get hasDomains() {
    return this._domains.length > 0
  }

  // Checks if the given class (type) is in the ranges. Returns boolean.
  // Parameter type is an Iri.
  classInRange(type) {
    return !!this._ranges.find((r) => r.equals(type))
  }

  // Checks if the given class (type) is in the domains. Returns boolean.
  // Parameter type is an Iri.
  classInDomain(type) {
    return !!this._domains.find((d) => d.equals(type))
  }
}

class OntoObjectProp extends OntoProp {
  constructor(type, range = [], domain = []) {
    super(type, range, domain)
  }
}

class OntoDatatypeProp extends OntoProp {
  constructor(type, range = [], domain = []) {
    super(type, range, domain)
  }
}

class Ontology {
  constructor() {
    this._scCache = new Map()
    this._subCache = new Map()
    this._namespaces = new Namespaces(serialization.prefixes)

    this._restrictions = []
    this._restrictions.push(new TypeRestriction(this.iri('rec:Space')))
    this._restrictions.push(
      new ObjectPropRestriction(
        this.iri('rec:includes'),
        this.iri('rec:RealEstate'),
        this.iri('rec:Building')
      )
    )
    this._restrictions.push(
      new ObjectPropRestriction(
        this.iri('rec:isPartOf'),
        this.iri('rec:Level'),
        this.iri('rec:Building')
      ).setMaxCount(1)
    )

    // TODO add parsing of labels and comments...
    this._classes = serialization.classes.map(
      (c) =>
        new OntoClass(
          this.iri(c.id),
          '',
          c.subClassOf?.map((sc) => this.iri(sc)) || []
        )
    )

    this._datatypeProps = serialization.datatypeProperties.map(
      (dtp) =>
        new OntoDatatypeProp(
          this.iri(dtp.id),
          dtp.ranges?.map((r) => this.iri(r)) || [],
          dtp.domains?.map((d) => this.iri(d)) || []
        )
    )

    this._objectProps = serialization.objectProperties.map(
      (op) =>
        new OntoObjectProp(
          this.iri(op.id),
          op.ranges?.map((r) => this.iri(r)) || [],
          op.domains?.map((d) => this.iri(d)) || []
        )
    )

    // TODO to avoid error...
    new Literal()
  }

  // Factory for namespaced Iris.
  // Parameter id is an iri string, potentially prefixed, ie. prefix:shortName, eg rec:Space.
  iri(id) {
    return new Iri(this._namespaces.expand(id), this._namespaces)
  }

  get classes() {
    return this._classes
  }

  get datatypeProps() {
    return this._datatypeProps
  }

  get objectProps() {
    return this._objectProps
  }

  // Returns array of type Iri or undefined if type doesnt exist.
  // Parameter type is an Iri.
  superclasses(type, iteration = 1) {
    if (this._scCache.has(type.value)) return this._scCache.get(type.value)

    const ontoClass = this._classes.find((c) => c.type.equals(type))

    if (ontoClass) {
      if (ontoClass.subClassOf.length) {
        const result = ontoClass.subClassOf
          .flatMap((sc) => this.superclasses(sc, iteration + 1) || [])
          .concat(ontoClass.subClassOf)
        this._scCache.set(type.value, result)
        return result
      } else {
        this._scCache.set(type.value, [])
        return []
      }
    }
    return undefined
  }

  subclasses(type) {
    if (this._subCache.has(type.value)) return this._subCache.get(type.value)

    const children = this._classes
      .filter((c) => c.subClassOf.find((sc) => sc.equals(type)))
      .map((c) => c.type)

    if (children.length) {
      const result = children
        .map((c) => this.subclasses(c))
        .reduce((prev, curr) => prev.concat(curr), [])
        .concat(children)
      this._subCache.set(type.value, result)
      return result
    }
    this._subCache.set(type.value, [])
    return []
  }

  // Parameter type is an Iri. May be omitted in which case all allowed classes are returned.
  neighbors(type) {
    console.log('>>>>> NEIGHBORS')
    console.log('wob-ontology-services.ontology.neighbors', type, typeof type)

    // Early return of all classes if no type is given.
    if (!type || !type.isDefined) return this.classes

    // Outgoing to open classes.
    const openDomains = this._objectProps.filter((op) => !op.hasDomains)
    // console.log('NEIGHBOR OPEN DOMAINS', type, openDomains)
    // Incoming from open classes.
    const openRanges = this._objectProps.filter((op) => !op.hasRanges)
    // console.log(
    //   'NEIGHBOR OPEN RANGES',
    //   type,
    //   openRanges //openRanges.map((or) => or.type.short)
    // )
    const classes = this.superclasses(type)
    // console.log('NEIGHBOR CLASSES', classes)

    // Outgoing to specific classes.
    const restrictingDomains = this._objectProps.filter((op) =>
      classes.find((c) => op.classInDomain(c))
    )
    // console.log(
    //   'NEIGHBOR RESTR DOMAINS',
    //   type,
    //   restrictingDomains.map((or) => or.type.short)
    // )
    // Incoming from specific classes.
    const restrictingRanges = this._objectProps.filter((op) =>
      classes.find((c) => op.classInRange(c))
    )
    // console.log(
    //   'NEIGHBOR RESTR RANGES',
    //   type,
    //   restrictingRanges.map((or) => or.type.short)
    // )

    function flatten(prev, curr) {
      return prev.concat(curr)
    }

    // TODO the opendomains is emtpy and hence throws in the statement below... refactor
    openDomains || true

    const neighborClasses = [
      //openDomains.map((op) => op.ranges).reduce(flatten),
      openRanges.map((op) => op.domains).reduce(flatten, []),
      restrictingDomains.map((op) => op.ranges).reduce(flatten, []),
      restrictingRanges.map((op) => op.domains).reduce(flatten, []),
    ]
      .reduce(flatten, [])
      .filter(
        (value, index, self) =>
          self.findIndex((item) => item.equals(value)) == index
      )
    // console.log('NEIGHBORS CLASSES', neighborClasses)

    const neighborSubclasses = neighborClasses
      .map((c) => this.subclasses(c))
      .reduce((prev, curr) => prev.concat(curr), [])

    // console.log('NEIGHBORS SUBCLASSES', neighborSubclasses)

    return [...neighborClasses, ...neighborSubclasses]
      .filter(
        (value, index, self) =>
          self.findIndex((item) => item.equals(value)) == index
      )
      .map((id) => this.classes.find((c) => c.type.equals(id)))
  }

  // TODO add max cardinality on restrictions to be able to exclude class options, eg no real estate on building already related to realestate
  adjacencies(type, incomingNeighbors = [], outgoingNeighbors = []) {
    console.log('ADJACENCIES', type, incomingNeighbors, outgoingNeighbors)

    const classes = this._restrictions
      .filter((r) => r instanceof TypeRestriction)
      .map((r) => r.types)
      .reduce((prev, curr) => prev.concat(curr), [])
      .map((id) => this.subclasses(id).concat(id))
      .reduce((prev, curr) => prev.concat(curr), [])
      .map((id) => this.classes.find((c) => c.type.equals(id)))
    console.log('CLASSES', classes)

    if (!type || !type.isDefined) return classes

    const triples = this._restrictions
      .filter((r) => r instanceof ObjectPropRestriction)
      .map((r) => r.triples)
      .reduce((prev, curr) => prev.concat(curr), [])

    console.log('TRIPLES', triples)

    const superclasses = this.superclasses(type)
    console.log('SUPERCLASSES', superclasses)

    const outgoing = triples.filter(([s]) =>
      superclasses.find((sc) => sc.equals(s) || type.equals(s))
    )
    console.log('OUTGOING', outgoing)

    const incoming = triples.filter(([, , o]) =>
      superclasses.find((sc) => sc.equals(o) || type.equals(o))
    )
    console.log('INCOMING', incoming)

    // TODO subclass expansions on objects for outgoing and subjects for incoming, include parent class.

    const outgoingX = outgoing
      .map(([s, p, o]) =>
        this.subclasses(o)
          .concat(o)
          .map((id) => [s, p, id])
      )
      .reduce((prev, curr) => prev.concat(curr), [])
    console.log('OUTGOING EXPANDED', outgoingX)

    const incomingX = incoming
      .map(([s, p, o]) =>
        this.subclasses(s)
          .concat(s)
          .map((id) => [id, p, o])
      )
      .reduce((prev, curr) => prev.concat(curr), [])

    console.log('INCOMING EXPANDED', incomingX)

    const _classes = [
      ...outgoingX.map(([, , o]) => o),
      ...incomingX.map(([s]) => s),
    ].map((_c) => this.classes.find((c) => c.type.equals(_c)))
    console.log('RESULTING CLASSES', _classes)

    return _classes
  }

  peers(focus, incoming = [], outgoing = []) {
    console.log(
      //'wob-ontology-services.ontology.peers',
      'PEERS',
      focus,
      incoming,
      outgoing
    )

    // TODO calculate in constructor...
    const allClasses = this._restrictions
      .filter((r) => r instanceof TypeRestriction)
      .map((r) => r.types)
      .reduce((prev, curr) => prev.concat(curr), [])
      .map((id) => this.subclasses(id).concat(id))
      .reduce((prev, curr) => prev.concat(curr), [])
      .map((id) => this.classes.find((c) => c.type.equals(id)))
    console.log('ALL CLASSES', allClasses)

    if (!focus || !focus.isDefined) return allClasses

    // Utility to check if a type is in a list of classes or their subclasses.
    // Parameter type is an Iri and classes is an array of Iris.
    const typeInSubclasses = (type, classes) => {
      console.log('TYPE IN SUBCLASSES', type, classes)

      const allSubclasses = classes
        .map((c) => this.subclasses(c).concat(c))
        .reduce((prev, curr) => prev.concat(curr), [])

      console.log('ALL SUBCLASSES', allSubclasses)

      const resulting = allSubclasses.find((sc) => sc.equals(type))
      console.log('RESULTING', resulting)
      return !!resulting
    }

    // function typeInSuperclasses(type, classes) {
    //   return !!classes
    //     .map((c) => this.superclasses(c).concat(c))
    //     .reduce((prev, curr) => prev.concat(curr), [])
    //     .find((sc) => sc.equals(type))
    // }

    // Restrictions on incoming.
    // If the incoming pattern can be found in an object property restriction that restriction is excldued.
    // Neighbor is source.
    const inRestrictions = this._restrictions
      .filter((r) => r instanceof ObjectPropRestriction)
      .filter((r) => typeInSubclasses(focus, r.targets))
      .filter(
        (r) =>
          !incoming.find(
            ([source, type]) =>
              type.equals(r.type) && typeInSubclasses(source, r.sources)
          )
      )
    console.log('IN RESTRICTIONS', inRestrictions)
  }
}

export { OntoClass, OntoObjectProp, OntoDatatypeProp, Ontology }
